// extracted by mini-css-extract-plugin
export default {"container":"HerramientasSugeridas_container__-OjrB","titulo":"HerramientasSugeridas_titulo__Z2jy4","listaArticulos":"HerramientasSugeridas_listaArticulos__BokeD"};